<span class="toggle-btn {{toggledSideMenu ? 'hidden-m-btn':'showen-m-btn'}}" data-toggle="collapse" (click)="toggleSideMenu()"></span>

<div *ngIf="Activated" class="nav-side-menu {{toggledSideMenu ? 'hidden-m':'showen-m'}} col-sm-3">
  <div class="menu-content-full">
    <div class="brand">
      <div class="row">
        <div class="col-md-3 col-sm-3" style="padding-top: 15px;">
          <i class="armx-user-circle-o" style="font-size:50px;"></i>
        </div>

        <div class="col-md-9 col-sm-9" >
         <span class="title" *ngIf="currentUser">{{currentUser?.FirstName +" "+currentUser?.LastName }}</span>
          <div class="loader-container" style="width:100%" *ngIf="!currentUser">
            <div class="text-loader" style="margin-top:30px"></div>
          </div>
        </div>
        <div class="col-md-8">
          <span class="sub-title">
            <div class="loader-container" style="width:100%" *ngIf="!currentUser" >
              <div class="text-loader" ></div>
            </div>
            <span *ngIf="currentUser">
              {{ 'common.roles' | translate }}
              <span *ngFor="let role of currentBranch?.branch?.Roles; index as j">
                <span [innerHtml]="getBranchRolesIcon(role.Role.Type)"></span>
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="menu-list">
      <ul id="menu-content" class="menu-content" *ngIf="disableSideMenu != false">
        <li class="side-logo">
          <div class="side-logo-bg">
            <div class="row">
              <div class="col-md-3 col-sm-3 col-xs-3" style="padding-top: 15px;padding-left: 28px;">
                <i class="armx-user-circle-o" style="font-size:50px;"></i>
              </div>
              <div class="col-md-9 col-sm-9 col-xs-9">
                <span class="point-title">{{currentUser?.FirstName +" "+currentUser?.LastName}}</span>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <h6 class="point-title" style="margin: 0 auto;text-align:left">
                    {{ 'common.roles' | translate }}
                    <span *ngFor="let role of currentBranch?.branch?.Roles; index as j">
                      <span [innerHtml]="getBranchRolesIcon(role.Role.Type)"></span>
                    </span>
                  </h6>
                </div>
              </div>

            </div>
          </div>
        </li>
        <li>
          <a routerLink="/dashboard/">
            <i class="armx-dashboard"></i> {{ 'sideMenu.dashboard' | translate }}
          </a>
        </li>
        <li *ngIf="hasOperationsRole" data-toggle="collapse" data-target="#operations" class="collapsed {{router.url.includes('operations') ? 'active' :''}}">
          <a><i class="armx-operations"></i> {{ 'sideMenu.operations.title' | translate }}</a>
        </li>
        <ul *ngIf="hasOperationsRole" class="sub-menu collapse" id="operations">
          <li class="menu-item" routerLink="/dashboard/operations/receivings">
            <i class=" armx-right-dir menu-item-icon"></i>{{ 'sideMenu.operations.title' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/operations/shipments-receiving">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.operations.shipmentReceiving' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/operations/jobs-handover">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.operations.jobsHandover' | translate }}
          </li>
          <!--li class="menu-item" routerLink="/dashboard/operations/warehouse-management"><i class=" armx-right-dir menu-item-icon"></i>Warehouse management</li>-->
          <!--<li class="menu-item" routerLink="/dashboard/operations/inventory"><i class="armx-right-dir menu-item-icon"></i>Inventory</li>-->
        </ul>

        <!--<li *ngIf="hasOperationsRole" routerLink="/dashboard/operations" class="collapsed {{router.url.includes('operations') ? 'active' :''}}">
    <a>
      <i class="armx-operations"></i> Operations
    </a>
  </li>-->
        <!--<li routerLink="/dashboard/shipments-receiving" class="collapsed {{router.url.includes('shipment-receiving') ? 'active' :''}}">
    <a>
      <i class="armx-operations"></i> shipment-receiving
    </a>
  </li>-->


        <li *ngIf="hasCashierRole" data-toggle="collapse" data-target="#cashier" class="collapsed {{router.url.includes('cashier') ? 'active' :''}}">
          <a><i class="armx-cashier"></i> {{ 'sideMenu.cashier.title' | translate }}</a>
        </li>
        <ul *ngIf="hasCashierRole" class="sub-menu collapse" id="cashier">
          <li class="menu-item" (click)="newReceipt()">
            <i class=" armx-right-dir menu-item-icon"></i>{{ 'sideMenu.cashier.newReceipt' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/cashier/receipts/">
            <i class=" armx-right-dir menu-item-icon"></i>{{ 'sideMenu.cashier.receipts' | translate }}
          </li>
          <li *ngIf="isDisabledOutbound" class="menu-item" routerLink="/dashboard/cashier/rate-calculator">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.cashier.rateCalculator' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/cashier/cashout">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.cashier.cashout' | translate }}
          </li>
        </ul>
        <li *ngIf="hasOutletManagerRole" data-toggle="collapse" data-target="#outletmanager" class="collapsed {{router.url.includes('outlet-manager') ? 'active' :''}}">
          <a><i class="armx-out-mgr"></i> {{ 'sideMenu.outletManager.title' | translate }}</a>
        </li>
        <ul *ngIf="hasOutletManagerRole" class="sub-menu collapse" id="outletmanager">
          <li class="menu-item" routerLink="/dashboard/outlet-manager/user-management">
            <i class=" armx-right-dir menu-item-icon"></i>{{ 'sideMenu.outletManager.userManagement' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/outlet-manager/branch-management">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.outletManager.branchManagement' | translate }}
          </li>
        </ul>
        <!--<li data-toggle="collapse" data-target="#new" class="collapsed ">
    <a><i class="armx-sup-admin"></i> Super Admin</a>
  </li>
  <ul class="sub-menu collapse" id="superAdmin">
    <li class="menu-item"><i class=" armx-right-dir menu-item-icon"></i>Super Admin 1</li>
    <li class="menu-item"><i class="armx-right-dir menu-item-icon"></i>Super Admin 2</li>
    <li class="menu-item"><i class="armx-right-dir menu-item-icon"></i>Super Admin 3</li>
  </ul>-->


        <li data-toggle="collapse" data-target="#settings" class="collapsed {{router.url.includes('settings') ? 'active' :''}}">
          <a><i class="armx-cog"></i> {{ 'sideMenu.settings.title' | translate }}</a>
        </li>
        <ul class="sub-menu collapse" id="settings">
          <li class="menu-item" routerLink="/dashboard/settings/printer-settings">
            <i class=" armx-right-dir menu-item-icon"></i> {{ 'sideMenu.settings.printerSettings' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/settings/scanner-settings">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.settings.scannerSettings' | translate }}
          </li>
          <li class="menu-item" routerLink="/dashboard/settings/topaz-settings">
            <i class="armx-right-dir menu-item-icon"></i>{{ 'sideMenu.settings.TopazSettings' | translate }}
          </li>
        </ul>
        <li routerLink="/dashboard/mfa">
          <a>
            <i class="armx-out-mgr"></i> {{ 'sideMenu.mfa' | translate }}
          </a>
        </li>
        <li (click)="signOut()">
          <a>
            <i class="armx-logout"></i> {{ 'sideMenu.signout' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>



